import { Layout } from 'client/app/apps/disco-prototype/components/PlateMapCanvas/common';
import { getColumnLabels, getRowLabels } from 'common/types/disco/wellCoords';

export const drawWells = (
  ctx: CanvasRenderingContext2D,
  layout: Layout,
  colourMap: Record<string, string>,
) => {
  const { cellW, cellH, radius, headerOffset, numColumns, numRows } = layout;

  ctx.save();
  ctx.lineWidth = 1;
  ctx.strokeStyle = '#999';

  getRowLabels(numRows).forEach((rowLabel, rIdx) => {
    getColumnLabels(numColumns).forEach((colLabel, cIdx) => {
      const id = `${rowLabel}${colLabel}`;
      const fill = colourMap[id] || '#ffffff';

      const cx = (cIdx + 0.5 + headerOffset) * cellW;
      const cy = (rIdx + 0.5 + headerOffset) * cellH;

      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fillStyle = fill;
      ctx.fill();
      ctx.stroke();
    });
  });
  ctx.restore();
};
